import zh from './zh';
import CURRENCY from '@/lang/currency';
import Vue from 'vue';
import { config } from 'CONFIG';
import VueI18n from 'vue-i18n';
import numberFormats from '@/lang/numberFormats';

Vue.use( VueI18n );

const lang = config.lang;

const messages = {

    zh: {

        ...zh,
        CURRENCY

    }

};

const i18n = new VueI18n({
    locale: lang,
    messages,
    numberFormats
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/oem/reolink-cn/index.js